var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.95,57.38h-20.26c-3.13,0-6.59-12.35-7.74-15.32-.99,2.96-4.45,15.32-7.58,15.32H4.12c-1.98,0-3.29-2.47-1.98-4.12L28.82,16.21l-3.95-5.6c-1.98-2.64,2.14-5.6,4.12-2.96l2.96,4.28,3.13-4.28c1.81-2.64,5.93.33,4.12,2.96l-4.12,5.6,26.84,37.06c1.15,1.65,0,4.12-1.98,4.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamping);
export default __webpack_public_path__ + "static/media/camping.aec593f0b795ff94c8575756dd58260a.svg";
export { ForwardRef as ReactComponent };